<template>
  <div class="head-cate">
    <ul
      ref="ul"
      @click="positionHandle"
    >
      <li
        v-for="item of list"
        :class="sId == item.cat_id ? 'action' : ''"
        :key="item.cat_id"
        @click="selectedCate(item.cat_id, $event)"
      >
        <img :src="item.cat_pic" />
        <p>{{ item.cat_name }}</p>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    },
    sId: {
      type: Number,
    }
  },
  model: {
    prop: 'sId',
    event: 'changeId'
  },
  data () {
    return {
    }
  },
  methods: {
    positionHandle () {

    },
    selectedCate (id, event) {
      this.$emit('changeId', id)
    }
  },
}
</script>
<style lang="scss" scoped>
.head-cate {
  background: #fff;
  margin: 0.1rem 0;
  padding: 0.1rem 0;

  ul {
    display: flex;
    min-width: 100vw;
    overflow-x: scroll;
    justify-content: space-between;
    scrollbar-width: none;
    -ms-overflow-style: none;
    padding: 0.1rem 0;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }

    li {
      flex: 1;
      text-align: center;
      margin: 0 0.1rem;

      p {
        margin: 0;
        font-size: 0.2rem;
        width: 1rem;
        // padding: 0.1rem;
        border: 1.5px solid #fff;
        border-radius: 10px;
        padding: 0.02rem 0.04rem;
      }

      img {
        width: 1rem;
        height: 1rem;
        // border: 1px solid #fff;
        // padding: 0.1rem;

        // border-radius: 30px;

      }
    }
  }
}

.action {
  img {
    // border-color: #5a9dff !important;
  }

  p {
    border-color: #5a9dff !important;
    color: #5a9dff !important;

  }
}
</style>
